<div class="border-0 legacy-card">
  <div class="card-body px-0">
    <ul class="menu-grid list-unstyled">
      <li>
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/home">
          <i class="fas fa-scroll fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Feeds</span>
        </a>
      </li>

      <li v-if="client_features.show_portals">
        <a class="text-dark" data-bs-toggle="offcanvas" href="#portals" role="button" aria-controls="portals">
          <i class="fas fa-th-large fa-fw text-black fs-2"></i>
          <span class="link-name fw-500 ms-2">{{ client_features.portals_label }}</span>
        </a>
      </li>

      <li v-if="client_features.show_library">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/library">
          <i class="fas fa-book-open fa-fw text-black fs-2"></i>
          <span class="ms-2">Library</span>
        </a>
      </li>

      <li class="d-none">
        <a href="/view_group" class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500">
          <i class="fas fa-user-group fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Groups</span>
        </a>
      </li>

      <li v-if="client_features.show_events">
        <a href="/view_events" class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500">
          <i class="fas fa-calendar-day fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Events</span>
        </a>
      </li>

      <li v-if="client_features.show_incident">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-gray text-xs fw-500" href="/incident_reporting">
          <i class="fas fa-screwdriver-wrench fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Maintenance</span>
        </a>
      </li>

      <li v-if="client_features.show_assets">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/community_asset">
          <i class="fas fa-cubes fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Assets</span>
        </a>
      </li>

      <li v-if="client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/marketplace">
          <i class="fas fa-store fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Marketplace</span>
        </a>
      </li>
      <li v-if="token_exists && client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/my_shop">
          <i class="fas fa-warehouse fa-fw text-black fs-3"></i>
          <span class="link-name ms-2">My Shop</span>
        </a>
      </li>
      <li v-if="client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/my_orders">
          <i class="fas fa-bag-shopping fa-fw text-black fs-2"></i>
          <span class="link-name ms-1">My Orders</span>
        </a>
      </li>

      <li class="d-none" v-if="client_features.show_services">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/create_service">
          <i class="fas fa-hand-holding-dots fa-fw text-black fs-2"></i>
          <span class="ms-2">Services</span>
        </a>
      </li>
      <li class="d-none" v-if="client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/ads_center">
          <i class="fas fa-bullhorn fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Ads Centre</span>
        </a>
      </li>
      <li>
        <a href="/dashboard" v-if="token_exists && user_details.user_role == 'admin'" class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500">
          <i class="fas fa-chart-pie fa-fw text-black fs-2"></i>
          <span class="link-name ms-2">Dashboard</span>
        </a>
      </li>

    </ul>
  </div>
</div>
